import Image from "@/components/Atoms/Image";
import styles from "./index.module.scss";

type MoodGalleryImage = {
	id?: string;
	url?: string;
	alt?: string | null;
	responsiveImage?: unknown;
};

type LimitedEditionMoodGalleryProps = {
	images?: MoodGalleryImage[];
};

export function LimitedEditionMoodGallery({
	images = [],
}: LimitedEditionMoodGalleryProps) {
	if (!images.length) return null;

	return (
		<div className={styles.moodGallery}>
			{images.map((image, index) => (
				<div key={image.id ?? index} className={styles.moodItem}>
					<div className={styles.moodImageWrap}>
						<Image
							objectFit="cover"
							className={styles.moodImage}
							data={image}
						/>
					</div>
				</div>
			))}
		</div>
	);
}
